import * as angular from "angular";
import {IController, IIntervalService} from "angular";
import * as _ from "lodash";

export class bringozCountdownCtrl implements IController {
  from: any;
  to: any;
  maxCount: any;
  keepCountWhenNegative: any;
  stopCount: any;
  negativeUntilFrom: boolean;
  onCurrentTimeChanged: Function;

  isLate: boolean;

  private DEFAULT_MAX_COUNT: any;
  private countDownIntervalRef: any;
  private displayTime: any;


  /* @ngInject */
  constructor(private $interval: IIntervalService, private moment, private $filter) {
  }

  $onInit() {
    this.DEFAULT_MAX_COUNT = 30; // In Minutes
    this.maxCount = (this.maxCount || this.DEFAULT_MAX_COUNT) * 60000;
    this._setDisplayTime();
  }

  $onChanges(changes) {
    if (changes.from || changes.to) {
      this.resetInterval();
    }
    if (changes.maxCount && !changes.maxCount.isFirstChange()) {
      this.resetInterval();
    }
  }

  $onDestroy() {
    if (this.countDownIntervalRef) {
      this.$interval.cancel(this.countDownIntervalRef);
    }
  }

  private resetInterval() {
    if (!this.countDownIntervalRef && !!this.stopCount) {
      this._setDisplayTime();
    } else {
      if (!!this.countDownIntervalRef) {
        this.displayTime = undefined;
        this.$interval.cancel(this.countDownIntervalRef);
        this.countDownIntervalRef = undefined;
      }
      this.countDownIntervalRef = this.$interval(() => {
        this._setDisplayTime();
      }, (1000));
    }
  }

  private _setDisplayTime() {
    const from = this.from || this.moment().valueOf()
    const until = this.to || (from + this.maxCount);
    const showTimer = this.keepCountWhenNegative || ((this.from || this.to) ? this.moment().isBefore(this.moment(until)) : false);
    const diffInHours = this.moment(until).diff(this.moment(), 'hours');

    if (!showTimer && (diffInHours >= 24 || diffInHours <= -24)) {
      this.displayTime = this.$filter('bringozTimeAgo')(until);
    } else {
      const seconds = showTimer ? this.moment(until).diff(from, 'seconds') : 0;
      // let displayTime = new Date(Math.abs(seconds) * 1000).toISOString().substr(11, 8);
      let duration = this.moment.duration(Math.abs(seconds), 'seconds');

      let daysRef = duration.days(),
          hoursRef = duration.hours(),
          minutesRef = duration.minutes(),
          secondsRef = duration.seconds()


      let displayTime = `${this._getPaddingZeroNumber(hoursRef)}:${this._getPaddingZeroNumber(minutesRef)}:${this._getPaddingZeroNumber(secondsRef)}`
      if (daysRef > 0) {
        displayTime = `${this._getPaddingZeroNumber(daysRef)}:${displayTime}`
      }

      // if (this.negativeUntilFrom) {
      //   //for service time to deliver
      //   displayTime = seconds > 0 ? '-' + displayTime : _.replace(displayTime, '-', '');
      // }
      // else {
      //   if (seconds < 0) {
      //     displayTime = `-${displayTime}`;
      //   }
      // }

      this.displayTime = displayTime;
      if (this.onCurrentTimeChanged) {
        this.onCurrentTimeChanged()
      }

    }
    this.isLate = this.moment(until).isBefore(this.moment())

  }

  private _getPaddingZeroNumber(number) {
    return number.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozCountdown', {
    bindings: {
      from: '<?',
      to: '<?',
      maxCount: '<?',
      keepCountWhenNegative: '<?',
      stopCount: '<?',
      negativeUntilFrom: '<?',
      onCurrentTimeChanged: '&?'
    },
    template: require('./bringoz-countdown.html').default,
    controller: bringozCountdownCtrl
  });
